




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { LearningGroupCourse, LearningPathInfo } from 'frontend/types';
import CourseItemContent from 'frontend/views/learningPaths/CourseItemContent.vue';

@Component({
  components: {
    CourseItemContent,
  },
  computed: {
    ...mapState('globals', ['user']),
  },
})
export default class CourseItem extends Vue {
  @Prop(Object) private readonly learningPath!: LearningPathInfo;
  @Prop(Object) private readonly course!: LearningGroupCourse;
  @Prop(Number) private readonly courseNumber!: number | undefined;
}
